
import React, { useMemo } from 'react';
import { Setlist, Button, Modal, Spinner } from "player-components";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link, useParams, useLocation } from "react-router-dom";
import platform from "platform";
import { formatDistance } from 'date-fns'

import {ArrowDownTrayIcon, ExclamationTriangleIcon} from "@heroicons/react/20/solid";
import ReactGA from "react-ga4";

import { selectSetlistSessions, selectLastCreatedSession, resetLastCreated, unpackSessionAsync, unpackSetlistAsync } from "../../features/setlist/setlistSlice";
import { openSession } from "../../features/session/sessionSlice";
import { addNotificationAsync, selectClientConfig, setError } from "../../features/ui/uiSlice";
import { selectUser } from "../../features/auth/authSlice";
import { fetchLibrarySongsByIdAsync, selectLibrarySongs, selectLibraryStatus} from '../../features/library/librarySlice';
import { removeSetListFromSetlists, removeSongFromSetlist, selectSetlistsSetlists, cacheSetlistAssetsAsync, uncacheSetlistAssetsAsync, selectSetlistsCachingProgress, selectSetlistsStatus, saveUserSetlistsToS3Async} from '../../features/setlists/setlistsSlice';

import { renameSetlist, updateSetlistStartFromSong } from "../../features/setlists/setlistsSlice";

import {createSessionFromSong} from '../../features/setlist/setlistSlice';
import ShareSetlistModal from '../../components/ShareSetlistModal';
import { generateShortLink } from '../../features/setlist/setlistAPI';
import NotFound from '../../components/NotFound';


// pgw 30-sep-2025 - replace all debugging debugLog calls with debugLog
import { debugLog } from '../../debugLog';


// pgw 16-jul-2025 - attempt to fix setlist bug
import { store, persistor } from '../../store';

import { logToIndexedDB, getLogsFromIndexedDB, clearLogsFromIndexedDB } from '../../indexedLogger';

// pgw 22-apr-2026 - testing CG integration
import { isCgTestingEnabled } from "../../utils/cgTesting";

import {
  isUgcTestingEnabled,
  fetchRemoteUgcSongById,
  normaliseUgcSong,
  getCurrentUgcUserEmail,
} from "../../utils/ugcTesting";

// pgw 09-feb-2026
let doprint = false;
// let doprint = true;

if (doprint) console.log("!!! doprint set true in player-application/src/containers/SetLists/index.js")
if (doprint) console.log("--------------------------------------------------------------------------")


if (doprint) console.log("[SETLIST INDEX] createSessionFromSong.type =", createSessionFromSong?.type);


// pgw 02-oct-2025
// connectivity probe you can call ad-hoc
async function isReallyOnline6(timeoutMs = 2000) {
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort('timeout'), timeoutMs);
  try {
    const res = await fetch('/_network-check?t=' + Date.now(), {
      cache: 'no-store',
      credentials: 'omit',
      signal: controller.signal
    });
    return res.ok;
  } catch {
    return false;
  } finally {
    clearTimeout(t);
  }
}


export const DEBUG_LOG_KEY = 'debugLogs';

export const logToLocalStorage = (message, payload = null) => {
	const logs = JSON.parse(localStorage.getItem(DEBUG_LOG_KEY)) || [];
	const timestamp = new Date().toISOString();

	const now = new Date();
	const ukTimeWithSeconds = now.toLocaleTimeString('en-GB', {
	  hour: '2-digit',
	  minute: '2-digit',
	  second: '2-digit',
	  timeZone: 'Europe/London',
	  hour12: false
	});

	let msg = `${ukTimeWithSeconds}`;


	if (payload) {
		msg = msg + ` m=${message} p=${payload}`
// 		logs.push({ message, payload });
		logs.push(msg);
	}
	else {

		msg = msg + ` m=${message}`
		logs.push(msg);
// 		logs.push(message);
	}
	// 	logs.push({ timestamp, message, payload });
	debugLog("message = ", message)
	localStorage.setItem(DEBUG_LOG_KEY, JSON.stringify(logs));
};


export function logAllSetlists(state) {

// debugLog('logAllSetlists 1')
	  logToIndexedDB('logAllSetlists 1');

	try {

// 	  logToIndexedDB('logAllSetlists 2 state = ', state);
// 	  debugLog('logAllSetlists 2 state = ', state);

	  const setlistsObj = state.setlists;
	  const setlists = setlistsObj.setlists;

	  logToIndexedDB('App Current setlists');
	  setlists.forEach(sl => {
		logToIndexedDB('App sl.title = ', sl.title);
		sl.items.forEach(song => {
			logToIndexedDB('App song.mix = ', song.mix);
		});
	  });
	}
	catch(e) {
  		logToIndexedDB('App logAllSetlists, e = ', e);
  		logToIndexedDB(e);
  		debugLog('App logAllSetlists, e = ', e);
	}
}




const SetListContainer = () => {
    
    const setlists = useSelector(selectSetlistsSetlists);
    const setlistSessions = useSelector(selectSetlistSessions);

	// pgw 31-jan-2026
	const setlistsById = useSelector(state => state.setlists.byId);

    const librarySongs = useSelector(selectLibrarySongs);
    const currentUser = useSelector(selectUser);
    const setlistsCachingProgress = useSelector(selectSetlistsCachingProgress);
    const libraryStatus = useSelector(selectLibraryStatus);
    const [setlistSongs, setSetlistSongs] = useState([]);


	const [currentSetlist, setCurrentSetlist] = useState(null);

    const clientConfiguration = useSelector(selectClientConfig);
    const user = useSelector(selectUser);
    const {id} = useParams();

	const currentSetlistFromRedux = useMemo(() => {
	  const foundSetlist = setlists.find((setlist) => setlist.id === id) || null;

	  if (doprint) console.log("[SETLIST VIEW] currentSetlistFromRedux", {
		id,
		found: !!foundSetlist,
		title: foundSetlist?.title,
		itemCount: foundSetlist?.items?.length || 0,
		songIds: foundSetlist?.items?.map((song) => song.songId),
	  });

	  return foundSetlist;
	}, [setlists, id]);

	const visibleSetlist = currentSetlistFromRedux || currentSetlist;


    const [showCacheSetlistModal, setShowCacheSetlistModal] = useState(false);
    const [showUncacheSetlistModal, setShowUncacheSetlistModal] = useState(false);
    const [showConfirmRemoveSetlistModal, setShowConfirmRemoveSetlistModal] = useState(false);
    const [showShareSetlistModal, setShowShareSetlistModal] = useState(false);
    const [showConfirmRemoveSongModal, setShowConfirmRemoveSongModal] = useState(null);
    const [generatingShareLink, setGeneratingShareLink] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const locationHook = useLocation();

    const [showSubscribeModal, setShowSubscribeModal] = useState(false);


	useEffect(()=>{

		// pgw 14-jul-2025
		debugLog('useEffect1 p1');
		const foundSetlist = setlists.find(s => s.id === id);
		debugLog('useEffect1 p2, foundSetlist = ', foundSetlist);

		setCurrentSetlist(foundSetlist || null);
	},[setlists, id]);

    useEffect(()=>{
        setSetlistSongs(librarySongs);
    }, [librarySongs, locationHook]);


	// pgw 26-jan-2026
	// pgw 27-mar-2026 - play all songs in songlist
	const handleOpenSong = async (songId, itemIxArg, options = {}) => {

	  // ✅ itemIxArg can be a number OR an object like { origin, setlistId, itemIx }
	  const itemIx =
		typeof itemIxArg === "number"
		  ? itemIxArg
		  : (itemIxArg && typeof itemIxArg === "object" ? itemIxArg.itemIx : undefined);

	  const setlistIdFromArg =
		(itemIxArg && typeof itemIxArg === "object") ? itemIxArg.setlistId : undefined;


	  // pgw 27-mar-2026 - play all songs in songlist
	  const autoStart = options?.autoStart === true;

	  if (doprint) console.log("[CONTAINERS_SETLIST_INDEX] in handleOpenSong", { songId, itemIxArg, itemIx, setlistIdFromArg });

	  // ... keep your existing debugLog lines here ...

	  if (libraryStatus !== "idle") {
		if (doprint) console.log("[CONTAINERS_SETLIST_INDEX] handleOpenSong blocked - libraryStatus = ", libraryStatus);
		return;
	  }

	  if (!currentUser.subscribed && !clientConfiguration.features.library.limitedLibrary.includes(songId)) {

		// pgw 22-apr-2026 - testing CG integration
		if (isCgTestingEnabled() == false) {
			setShowSubscribeModal(true);
			return;
		}

	  }

	  // ✅ prefer setlistId passed in arg (more reliable), else fall back to currentSetlist
	  const setlistId = setlistIdFromArg || currentSetlist?.id;

	  if (typeof itemIx !== "number") {
		if (doprint) console.warn("[SETLIST OPEN] itemIx is not a number", { songId, itemIxArg, itemIx });
		return;
	  }

	  if (!setlistId) {
		if (doprint) console.warn("[SETLIST OPEN] missing setlistId", { setlistId, songId, itemIx });
		return;
	  }

	  const item = currentSetlist?.items?.[itemIx];

	  // IMPORTANT: the setlist item often doesn't include stems/track metadata.
	  // Always prefer the canonical song object from the library.
	  

	  // pgw 24-apr-2026
	  // const song = librarySongs?.find(s => s.songId === songId) || item;



	  let song = isCgTestingEnabled()
		? item
		: (
			librarySongs?.find(s => s.songId === songId) ||
			item
		  );

	  if (isUgcTestingEnabled()) {
		const remoteUgcSong = await fetchRemoteUgcSongById(songId);

		if (remoteUgcSong) {
		  song = remoteUgcSong;
		}

		if (doprint) {
			console.log("[UGC] SetList handleOpenSong using song =", {
			  requestedSongId: songId,
			  actualSongId: song?.songId,
			  mix: song?.mix,
			  chaptersCount: song?.chapters?.length || 0,
			  lyrics: song?.lyrics,
			  lyricsUrl: song?.lyricsUrl,
			  fromRemote: !!remoteUgcSong,
			});
		}

	  }

	  const normalisedSong = isUgcTestingEnabled()
		? normaliseUgcSong(song)
		: song;


	  if (!song) {
		if (doprint) console.warn("[SETLIST OPEN] no setlist item/song found", { setlistId, songId, itemIx });
		return;
	  }

	  if (!normalisedSong) {
		if (doprint) console.warn("[SETLIST OPEN] no setlist item/song found", { setlistId, songId, itemIx });
		return;
	  }

	  const songIdFromSong = normalisedSong.songId || songId;

	  // ✅ ONE consistent place for setlist-scoped settings (see note below)
	  const restoreSettings = item?.itemSettings || null;

	  if (doprint) console.log("[SETLIST OPEN] dispatch createSessionFromSong payload", {
		setlistId,
		itemIx,
		songIdFromSong,
		hasSong: true,
		hasRestoreSettings: !!restoreSettings,
		restoreStemCount: restoreSettings?.stems?.length,
	  });


	  await dispatch(createSessionFromSong({
		song: normalisedSong,
		title: normalisedSong.mix,
		restoreSettings,

		origin: {
			type: "setlist",
			setlistId,
			cgSetlistId: currentSetlist?.cgSetlistId,
			itemIx,
			songId: songIdFromSong,
		},

	  }));

	  // Mirror the Library open flow: open the newly created session.
	  const newId = store.getState().setlist?.lastCreatedSession;
	  const created = store.getState().setlist?.sessions?.find(s => s.id === newId);
	  if (doprint) console.log("[SETLIST OPEN] created session lookup", {
		newId,
		found: !!created,
		stems: created?.stems?.length,
		origin: created?.origin,
	  });

	  if (created) {


		if (doprint) console.log("[PLAY SETLIST] marking initial session for autoplay created = ", created);
		if (doprint) console.log("[PLAY SETLIST] marking initial session for autoplay autoStart = ", autoStart);

		// pgw 27-mar-2026 - play all songs in songlist
		dispatch(openSession(created));

		if (autoStart) {
		  if (doprint) console.log("[PLAY SETLIST] marking initial session for autoplay start", created.id);
		  window.__PENDING_AUTOPLAY_SESSION_ID__ = created.id;
		}

		dispatch(resetLastCreated());
		navigate("/session");

	  } else {
		if (doprint) console.warn("[SETLIST OPEN] could not find created session", { newId, setlistId, itemIx, songId: songIdFromSong });
	  }

	};



    const deleteSong = async () => {
        dispatch(removeSongFromSetlist({
            setlistId: id,
            songId: showConfirmRemoveSongModal
        }));

		// pgw 13-jul-2025 remove notifications, as they mess with setlists and can break player rendering
		/*
        dispatch(addNotificationAsync({
            title: 'Removed',
            text: `${selectedSong.mix} removed from setlist`,
            type: 'negative',
        }));
		*/

        setShowConfirmRemoveSongModal(null);
    }

    const handleUploadSession = async (file) => {
        const sessionZipArrayBuffer = await file.arrayBuffer();
        if (file.name.includes('.setlist')) {
            await dispatch(unpackSetlistAsync(sessionZipArrayBuffer));

			// pgw 13-jul-2025 remove notifications, as they mess with setlists and can break player rendering
			/*
            await dispatch(addNotificationAsync({
                type: 'positive',
                title: 'Complete',
                text: 'Songs were added to your setlist'
            }));
			*/

        }
        if (file.name.includes('.session')) {
            await dispatch(unpackSessionAsync(sessionZipArrayBuffer));

			// pgw 13-jul-2025 remove notifications, as they mess with setlists and can break player rendering

            /*
			await dispatch(addNotificationAsync({
                type: 'positive',
                title: 'Complete',
                text: 'Session added to your setlist'
            }));
			*/

        }
    }



    const handleCacheSetlist = async () => {

		debugLog('handleCacheSetlist p1 currentSetlist.cached = ', currentSetlist.cached)


		// pgw 02-oct-2025
		const ok = await isReallyOnline6(2500);
		if (ok) {
			debugLog('user is online')
		}
		else {
			debugLog('user is offline !!')

			let confStr = "You are offline !"

			if (currentSetlist.cached) {
				confStr = confStr + "\n" + "If you do this, you will not be able to play songs in this setlist until you are back online !"
				confStr = confStr + "\n" + "\n" + "Are you sure you want to continue ?"
				confStr = confStr + "\n" + "(OK to continue; Cancel to do nothing)"
			} else {
				confStr = confStr + "\n" + 'Setting "Available offline" does NOT work when offline.'
				confStr = confStr + "\n" + "\n" + "Are you absolutely sure you want to continue ?"
				confStr = confStr + "\n" + "(OK to continue; Cancel to do nothing)"
			}

			let res = confirm(confStr)
			if (res) {
				debugLog("You pressed OK!");
			} else {
				debugLog("You pressed Cancel - returning...");
				return;
			}

		}


        if (currentSetlist.cached) {
            setShowUncacheSetlistModal(true);
        } else {
            setShowCacheSetlistModal(true);
        }
    }

    const handleRemoveSetlist = async () => {

// 
		logToIndexedDB("handleRemoveSetlist p1");

		try {
			// log the current setlists
			let state = store.getState();

			logToIndexedDB('handleRemoveSetlist before logAllSetlists p1')
			logAllSetlists(state);
			logToIndexedDB('handleRemoveSetlist after logAllSetlists p2')
		}
		catch(e) {
			logToIndexedDB('handleRemoveSetlist p1, e = ', e)
			debugLog('handleRemoveSetlist p1, e = ', e)
		}


			logToIndexedDB('handleRemoveSetlist before dispatch(uncacheSetlistAssetsAsync) p1')

        await dispatch(uncacheSetlistAssetsAsync(currentSetlist));
			logToIndexedDB('handleRemoveSetlist after dispatch(uncacheSetlistAssetsAsync) p1')


			logToIndexedDB('handleRemoveSetlist before dispatch(removeSetListFromSetlists) p1')
        dispatch(removeSetListFromSetlists(id))
			logToIndexedDB('handleRemoveSetlist after dispatch(removeSetListFromSetlists) p1')

		if (window.localStorage.getItem("saveSetlists") === "1") {
			  logToIndexedDB('handleRemoveSetlist before dispatch(saveUserSetlistsToS3Async) p1')
		  await dispatch(saveUserSetlistsToS3Async()).unwrap();
			  logToIndexedDB('handleRemoveSetlist after dispatch(saveUserSetlistsToS3Async) p1')
		} else {
			  logToIndexedDB('handleRemoveSetlist skipping saveUserSetlistsToS3Async because saveSetlists is not 1')
		}

		try {
			// log the current setlists
			let state = store.getState();

			logToIndexedDB('handleRemoveSetlist before logAllSetlists p4')
			logAllSetlists(state);
			logToIndexedDB('handleRemoveSetlist after logAllSetlists p5')
		}
		catch(e) {
			logToIndexedDB('handleRemoveSetlist p6, e = ', e)
			debugLog('handleRemoveSetlist p6, e = ', e)
		}



        navigate('/setlists')
    }


	// pgw 09-feb-2026
	// Leave this here, but be aware that the functionality does NOT work right now.
	const handleRenameSetlist = async () => {
	  if (!currentSetlist?.id) return;

	  const currentTitle = currentSetlist.title || "";
	  const currentSubtitle = currentSetlist.subTitle || "";

	  const newTitle = window.prompt("New setlist name:", currentTitle);
	  if (newTitle == null) return; // cancelled

	  const trimmedTitle = String(newTitle).trim();
	  if (!trimmedTitle) {
		alert("Setlist name cannot be empty.");
		return;
	  }

	  const newSubtitle = window.prompt("New subtitle (optional):", currentSubtitle);
	  if (newSubtitle == null) return; // cancelled

	  const trimmedSubtitle = String(newSubtitle).trim();

	/*

	  // Optional: prevent duplicates (if you want)
	  // if (setlistTitleExists(trimmedTitle, setlists)) { ... }

	  // prevent duplicates (ignoring this setlist's own title)
	  const normalised = trimmedTitle.toLowerCase();
	  const dup = (setlists || []).some(s =>
		s?.id !== currentSetlist.id &&
		typeof s?.title === "string" &&
		s.title.trim().toLowerCase() === normalised
	  );

	  if (dup) {
		alert("You already have a setlist with that name.");
		return;
	  }
	*/

	  dispatch(renameSetlist({
		setlistId: currentSetlist.id,
		title: trimmedTitle,
		subTitle: trimmedSubtitle,
	  }));
	};

    const startSetlistCache = () => {
        setShowCacheSetlistModal(false);
        dispatch(cacheSetlistAssetsAsync(currentSetlist));
    }

    const startSetlistUncache = () => {
        setShowUncacheSetlistModal(false);
        dispatch(uncacheSetlistAssetsAsync(currentSetlist));
    }

    const handleNewSession = (sessionName) => {
        // dispatch(createEmptySession({
        //     title:sessionName
        // }));
    }

    const handleShareSetlist = () => {
        // setShowShareSetlistModal(true);
        ReactGA.event(
            'share_setlist',
            currentSetlist
          );
    }


	// pgw 27-mar-2026 - play all songs in songlist
	const handlePlaySetlist = async () => {
	  if (!currentSetlist?.items?.length) {
		alert("This setlist has no songs.");
		return;
	  }

	  if (!isCurrentSetlistOfflineReady()) {
		alert("To play a setlist continuously, first make the full setlist available offline.");
		return;
	  }

	  const startFromSong = Math.min(
		Math.max(Number(currentSetlist.startFromSong) || 1, 1),
		currentSetlist.items.length
	  );
	  const startItemIx = startFromSong - 1;
	  const startItem = currentSetlist.items[startItemIx];
	  if (!startItem?.songId) {
		alert("Could not find the selected song in this setlist.");
		return;
	  }

	  if (doprint) console.log("[PLAY SETLIST] starting setlist", {
		setlistId: currentSetlist.id,
		startSongNumber: startFromSong,
		startSongId: startItem.songId,
	  });

	  await handleOpenSong(startItem.songId, {
		origin: "setlist",
		setlistId: currentSetlist.id,
		itemIx: startItemIx,
	  }, {
		autoStart: true,
	  });
	};

	/*
	const isCurrentSetlistOfflineReady = () => {
	  if (!currentSetlist?.items?.length) return false;

	  return currentSetlist.items.every((item) => {
		const song = (librarySongs || []).find((s) => s.songId === item.songId) || item;
		return song?.onDevice === true;
	  });
	};
	*/


	const isCurrentSetlistOfflineReady = () => {

	  if (doprint) console.log("[PLAY SETLIST] isCurrentSetlistOfflineReady currentSetlist", currentSetlist);
	  if (currentSetlist) {
	  	if (doprint) console.log("[PLAY SETLIST] isCurrentSetlistOfflineReady currentSetlist?.cached", currentSetlist?.cached);
	  }
	  else {
	  	if (doprint) console.log("[PLAY SETLIST] isCurrentSetlistOfflineReady currentSetlist undefined, so fn will fail");
	  }

	  return currentSetlist?.cached === true;
	};



    const handleGoToLibrary = () => {
		// // pgw 30-may-2024 testing
		debugLog('pgw handleGoToLibrary, currentSetlist.readOnly = ', currentSetlist.readOnly)
		debugLog('pgw handleGoToLibrary, currentSetlist = ', currentSetlist)
        navigate(`/library`);
    }

    const isSongSupported = (songId) => {
		// pgw 24-mar-2024
		// For choirplayer, do not show "Not supported on this device", because all songs should work.
		return true;
        if ( clientConfiguration.logic.restrictedDevices.includes(platform.product) && !clientConfiguration.features.library.songsWorkingOnIos.includes(songId)) {
            return false;
        } else if (platform.os?.family === 'OS X' && navigator.maxTouchPoints) { // is iPad
            if (!clientConfiguration.features.library.songsWorkingOnIos.includes(songId)) {
                return false;
            }
        }
        return true;
    }

    const renderNotSupported = () => {
        return <div className="flex items-center"><ExclamationTriangleIcon className="h-4 w-4 mr-2 text-primary" /><span className="text-sm">Not supported on this device</span></div>
    }

/*
    const formUrlFromSetlist = (setlist) => {
        return `${window.location.origin}${process.env.PUBLIC_URL}/#/setlist/create?setlistId=${setlist.id}&title=${setlist.title}&subtitle=${setlist.subTitle}&imageUrl=${btoa(setlist.imageUrl)}&items=${setlist.items.map(s => s.songId)}`;
    }

    const generateShareUrlCallback = async () => {
        const longUrl = formUrlFromSetlist(currentSetlist);
        if (clientConfiguration.features.setlist.urlShortenerUrl) {
            try {
                setGeneratingShareLink(true);
                const shortUrl = await generateShortLink(clientConfiguration.features.setlist.urlShortenerUrl, longUrl);
                setGeneratingShareLink(false);
                return shortUrl;
            } catch (e) {
                dispatch(setError({
                    title: 'Could not share',
                    text:'There was an error creating the setlist share link.'
                }));
            }
        } else {
            return longUrl
        }
    }
*/

    // pgw 01-feb-2026: include per-item mixer settings when sharing a setlist.
    // We keep it URL-friendly by base64url-encoding a JSON array aligned with items[].
    const toBase64Url = (str) => {
        try {
            const b64 = btoa(unescape(encodeURIComponent(str)));
            return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
        } catch (e) {
            console.warn('[SETLIST SHARE] failed to encode settings', e);
            return null;
        }
    };


	const normaliseSpeed = (v) => {
	  if (v == null) return v;
	  if (typeof v === "object" && v.value != null) return v.value;
	  const n = Number(v);
	  return Number.isFinite(n) ? n : v;
	};

	const normalisePitch = (v) => {
	  if (v == null) return v;
	  if (typeof v === "object" && v.value != null) return v.value;
	  const n = Number(v);
	  return Number.isFinite(n) ? n : v;
	};

	const normaliseItemSettings = (raw) => {
	  if (!raw) return null;

	  const stems = Array.isArray(raw.stems) ? raw.stems : [];

	  // ensure a stable shape that your create/import side can rely on
	  const norm = {
		stems: stems.map((s, idx) => ({
		  index: (s?.index ?? idx),                 // always have index
		  level: (s?.level ?? 1),
		  muted: !!s?.muted,
		  soloed: !!s?.soloed,
		  pan: (s?.pan ?? 0.5),
		})),
		speed: normaliseSpeed(raw.speed),
		pitch: normalisePitch(raw.pitch),
		masterMute: !!raw.masterMute,
		updatedAt: raw.updatedAt || new Date().toISOString(),
	  };

	  return norm;
	};

	const formUrlFromSetlist = (setlist) => {
	  if (doprint) console.log("[SETLIST SHARE] formUrlFromSetlist setlist = ", setlist);

	  const base = `${window.location.origin}${process.env.PUBLIC_URL}/#/setlist/create`;

	  const items = Array.isArray(setlist?.items) ? setlist.items : [];

	  // build BOTH arrays from the same iteration so order cannot drift
	  const songIds = [];
	  const itemSettingsByIx = [];
	  const ugcOwnersByIx = [];

	  for (const item of items) {
		songIds.push(item?.songId);

		// accept either field name (your codebase uses both in different places)
		const rawSettings = item?.itemSettings ?? item?.settings ?? null;

		itemSettingsByIx.push(normaliseItemSettings(rawSettings));

		const isUgcSong =
		  String(item?.songId || "").startsWith("ugc-") ||
		  item?.genre === "UGC";

		ugcOwnersByIx.push(
		  isUgcSong
		    ? (item?.ugcOwnerEmail || getCurrentUgcUserEmail())
		    : null
		);
	  }


	  const hasAnyItemSettings = itemSettingsByIx.some(Boolean);
	  const hasAnyUgcItems = ugcOwnersByIx.some(Boolean);

	  const settingsParam = hasAnyItemSettings
		? toBase64Url(JSON.stringify(itemSettingsByIx))
		: null;

	  const ugcOwnersParam = hasAnyUgcItems
		? toBase64Url(JSON.stringify(ugcOwnersByIx))
		: null;



	  if (doprint) console.log("[SETLIST SHARE] formUrlFromSetlist hasAnyItemSettings = ", hasAnyItemSettings);
	  if (hasAnyItemSettings) {
		if (doprint) console.log(
		  "[SETLIST SHARE] first itemSettings preview = ",
		  itemSettingsByIx[0]
		);
	  }

	  const qs = [
		`setlistId=${encodeURIComponent(setlist.id)}`,
		`title=${encodeURIComponent(setlist.title || "")}`,
		`subtitle=${encodeURIComponent(setlist.subTitle || "")}`,
		`imageUrl=${encodeURIComponent(btoa(setlist.imageUrl || ""))}`,
		`items=${encodeURIComponent(songIds.join(","))}`,
		...(settingsParam ? [`settings=${encodeURIComponent(settingsParam)}`] : []),
		...(ugcOwnersParam ? [`ugcOwners=${encodeURIComponent(ugcOwnersParam)}`] : []),
	  ].join("&");

	  return `${base}?${qs}`;
	};




    const generateShareUrlCallback = async (setlist = visibleSetlist) => {
        if (!setlist?.id) {
            dispatch(setError({
                title: 'Could not share',
                text: 'The setlist is not available. Please reopen it and try again.'
            }));
            return null;
        }

        const longUrl = formUrlFromSetlist(setlist);

        if (doprint) console.log('generateShareUrlCallback longUrl = ', longUrl)
        if (clientConfiguration.features.setlist.urlShortenerUrl) {
            setGeneratingShareLink(true);
            try {
                const shortUrl = await generateShortLink(clientConfiguration.features.setlist.urlShortenerUrl, longUrl);
                if (doprint) console.log('generateShareUrlCallback shortUrl = ', shortUrl)
                return shortUrl;
            } catch (e) {
                dispatch(setError({
                    title: 'Could not share',
                    text:'There was an error creating the setlist share link.'
                }));
                return null;
            } finally {
                setGeneratingShareLink(false);
            }
        } else {
            return longUrl
        }
    }



	// pgw 30-may-2024 testing: set showActionButton and showRemoveActionButton to true
	// They were both set to !currentSetlist.readOnly which may account for button only appearing in Chrome...

	// pgw 08-feb-2026
/*
                  <Button id="trigger-share" size="sm" type="primary">
              <div className="mt-5 flex flex-col space-y-4 flex-start sm:mt-0">

			<div className="flex justify-end mb-2">
			<div className="flex justify-end mb-2">


*/



    return <>
    {
		visibleSetlist && (libraryStatus == 'idle') && 
		(
		  <>
			<Setlist


				onPlaySetlist={handlePlaySetlist}
				showPlaySetlistButton={visibleSetlist?.items?.length > 0}
				startFromSong={Math.min(Math.max(Number(visibleSetlist.startFromSong) || 1, 1), visibleSetlist.items.length)}
				onStartFromSongChange={(startFromSong) => dispatch(updateSetlistStartFromSong({
					setlistId: visibleSetlist.id,
					startFromSong,
				}))}
				items={visibleSetlist.items.map((song, idx) => {

					return {
						id: song.songId,
						title: <><span>{song.mix}</span> {!isSongSupported(song.songId) ? renderNotSupported(): null}</>,
						artist: song.artist,
						genre: song.genre,
						decade: song.decade,
						key: song.key,
						time: song.len,
						state: "IN_SETLIST",
						// trackCount: stems.concat(userStems).length,
						lastSavedAt: formatDistance(new Date(), new Date(), { addSuffix: true }),
						trackIndex: idx + 1,

						
						// pgw 20-apr-2026 - testing CG integration
						// showActionButton: true,
						// showRemoveActionButton: true,

						showActionButton: !visibleSetlist.readOnly,
						showRemoveActionButton: !visibleSetlist.readOnly,

						removeLabel: "Remove",
						createdBy: Date.now(),
						// pgw 25-jan-2026
		//                 onSelected: ()=>handleOpenSong(song.songId),
		//                 onRemoveAction: ()=>setShowConfirmRemoveSongModal(song.songId)

						onSelected: ()=>{
							// pgw 26-jan-2026
							if (doprint) console.log("[CONTAINERS_SETLIST_INDEX] calling handleOpenSong, song.songId = ", song.songId)

							// pgw 28-jan-2206
							// handleOpenSong(song.songId)
							if (doprint) console.log("[CONTAINERS_SETLIST_INDEX] calling handleOpenSong, idx = ", idx)
							if (doprint) console.log("[CONTAINERS_SETLIST_INDEX] open", { songId: song.songId, itemIx: idx, setlistId: visibleSetlist?.id });

							handleOpenSong(song.songId, {
							  origin: "setlist",
							  setlistId: visibleSetlist.id,
							  itemIx: idx,
							});

							},
						onRemoveAction: ()=>{
							if (doprint) console.log("[CONTAINERS_SETLIST_INDEX] calling setShowConfirmRemoveSongModal, song.songId = ", song.songId)
							setShowConfirmRemoveSongModal(song.songId)
						}

					}
				})}
				sortedBy={{
					"label": "Title",
					"dir": "desc"
				}}
				showDownloadButton={(setlistSongs?.length > 0) && clientConfiguration.features.setlist.downloadSetlist}
				showRenameSession={clientConfiguration.features.setlist.renameSession}
				onDownloadSetlist={handleCacheSetlist}
				onShareSetlist={handleShareSetlist}
				onRenameSetlist={handleRenameSetlist}
				showShare={(user?.subscribed && setlistSongs?.length > 0)}
				generateShareUrlCallback={visibleSetlist ? async () => await generateShareUrlCallback(visibleSetlist): null}
				onDeleteSetlist={()=>setShowConfirmRemoveSetlistModal(true)}
				showHeader={clientConfiguration.features.setlist.showHeader}

				cached={visibleSetlist.cached}
				cacheProgress={setlistsCachingProgress}
				title={visibleSetlist.title}
				subTitle={visibleSetlist.subTitle}
				imageUrl={visibleSetlist.imageUrl}

				onUpload={handleUploadSession}
				onNewSession={handleNewSession}
				onGoToLibrary={handleGoToLibrary}
				emptyLinkComponent={<Link to={'/library'}><Button>Go to Song library</Button></Link>}
			/>
		  </>
		)

	}


    {!visibleSetlist && <div className="flex justify-center mt-4 mb-4"><NotFound /> </div>}


	<ShareSetlistModal 
		setlist={visibleSetlist}
		isOpen={showShareSetlistModal}

        onClose={()=>setShowShareSetlistModal(false)}
        />
    <Modal 
        isOpen={showCacheSetlistModal ? true:false}
        title="Download your setlist"
        text={<p>Downloading your setlist allows you to play the songs offline.</p>}
        confirmLabel="Download"
        
        onConfirm={startSetlistCache}
        onClose={()=>setShowCacheSetlistModal(false)}
        closeLabel="Close"
      />
      <Modal 
        isOpen={showUncacheSetlistModal ? true:false}
        title="Remove setlist download"
        text={<p>Uncaching your setlist will mean you are unable to play the songs offline.</p>}
        confirmLabel="Delete download"

        onConfirm={startSetlistUncache}
        onClose={()=>setShowUncacheSetlistModal(false)}
        closeLabel="Close"
      />
    <Modal 
        isOpen={showConfirmRemoveSetlistModal ? true:false}
        title="Delete setlist"
        text={<p>Are you sure you'd like to delete this setlist?</p>}
        confirmLabel="Delete"
        // icon={<ExclamationTriangleIcon className="h-20 w-20 text-primary" aria-hidden="true" />}
        onConfirm={handleRemoveSetlist}
        onClose={()=>setShowConfirmRemoveSetlistModal(false)}
        closeLabel="Close"
      />
    <Modal 
        isOpen={showConfirmRemoveSongModal ? true:false}
        title="Remove song"
        text={<p>Are you sure you'd like to remove this song from this setlist?</p>}
        confirmLabel="Remove"
        icon={<ExclamationTriangleIcon className="h-20 w-20 text-primary" aria-hidden="true" />}
        onConfirm={deleteSong}
        onClose={()=>setShowConfirmRemoveSongModal(null)}
        closeLabel="Close"
      />
    <Modal 
        isOpen={generatingShareLink}
        content={<div className="flex flex-col justify-center text-center">
        <div className="flex justify-center mb-4"><Spinner /></div>
        <h1 className="text-lg">Generating share link</h1>
      </div>}
        onClose={()=>{}}
      />
    {!currentUser?.subscribed && <Modal 
        isOpen={showSubscribeModal}
        title={clientConfiguration.features.library.subscribeConfig.libraryPromoText}
        content={<>
        <p>{clientConfiguration.features.library.subscribeConfig.text}</p>
        </>}
        closeLabel="Close"
        onConfirm={()=>window.location.href = clientConfiguration.features.library.subscribeConfig.url}
        confirmLabel="Subscribe now"
        onClose={()=>{setShowSubscribeModal(false)}}
        />}


    </>
}

export default SetListContainer;
